import { Container, Stack, Title } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { ToolBlacklistSection } from "../features/toolBlacklist/ToolBlacklistSection";

// Страница «Настройки → Запрещённые инструменты». Тонкий контейнер
// над секцией управления per-(org, role) blacklist'ом инструментов — как
// `ReviewerChecklistPage`.
export function ToolBlacklistPage(): ReactElement {
  const { t } = useTranslation();
  return (
    <Container py="xl">
      <Stack gap="xl">
        <Title order={1}>{t("toolBlacklist.pageTitle")}</Title>
        <ToolBlacklistSection />
      </Stack>
    </Container>
  );
}
